'use client';

import React from 'react';
import Image from 'next/image';
import { StyledPlatofrmHero } from './platformHero.styles';
import { IPlatform } from '../../types';

interface IPlatformHeroProps {
    platform: Pick<IPlatform, "title" | "icon" | "appSynonym" | "subTitle" | "siteSynonym">;
}

export const PlatformHero = ({ platform }: IPlatformHeroProps) => {
    return (
        <StyledPlatofrmHero>
            <div className="hero-wrapper">
                <div className='platform-img-wrapper'>
                    <Image src={platform.icon} alt={platform.title} fill />
                </div >
                <h1>{platform.title} <span>{platform.appSynonym}s</span> by Common Ninja</h1>
                <h2>{platform.subTitle || `Take your ${platform.title} ${platform.siteSynonym} to the next level with our extensive collection of powerful ${platform.appSynonym}s.
Stay ahead of the competition by enhancing your ${platform.siteSynonym}’s design, improving user experience, making products more visible, and boosting sales.`}</h2>
            </div>
        </StyledPlatofrmHero>
    );
};
